import * as fromDatatype from '../datatype-library/index';

export interface bl_del_shipment_import_file_helper_RowInterface {
    // Columns in the table
    container_reference: fromDatatype.VarcharDatatypeInterface;
    customer_marking: fromDatatype.VarcharDatatypeInterface;
    po_number: fromDatatype.VarcharDatatypeInterface;
    shipment_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    cbm: fromDatatype.NumericDatatypeInterface;
    total_qty: fromDatatype.NumericDatatypeInterface;
    total_weight: fromDatatype.NumericDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    sequence: fromDatatype.VarcharDatatypeInterface;
    item_desc: fromDatatype.VarcharDatatypeInterface;
    container_desc: fromDatatype.VarcharDatatypeInterface;

    // Other fields
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    validated: boolean;
    processed: boolean;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_shipment_import_file_helper_RowClass implements bl_del_shipment_import_file_helper_RowInterface {
    // Columns in the table
    container_reference: fromDatatype.VarcharDatatypeInterface;
    customer_marking: fromDatatype.VarcharDatatypeInterface;
    po_number: fromDatatype.VarcharDatatypeInterface;
    shipment_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    cbm: fromDatatype.NumericDatatypeInterface;
    total_qty: fromDatatype.NumericDatatypeInterface;
    total_weight: fromDatatype.NumericDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    sequence: fromDatatype.VarcharDatatypeInterface;
    item_desc: fromDatatype.VarcharDatatypeInterface;
    container_desc: fromDatatype.VarcharDatatypeInterface;

    // Other fields
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    validated: boolean;
    processed: boolean;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}